// Shared palette, lookups, and formatters for the Carry-Forward feature.
// Keeping these in one place so the table, dialog, and field components
// all agree on labels/colors instead of drifting apart.

export const colors = {
    primary: "#4B49AC",
    primaryDark: "#37357D",
    primaryLight: "#EEEDF9",
    text: "#1F2937",
    secondary: "#6B7280",
    border: "#E6E9ED",
    background: "#FAFBFC",
    green: "#1D9A6C",
    greenLight: "#E6F6EF",
    red: "#E14B4B",
    redLight: "#FDECEC",
    blue: "#3873D9",
    blueLight: "#EAF1FC",
  };
  
  // PENDING is a starting state, not something an admin picks.
  // APPROVED is kept here for display only (in case older records carry it)
  // but intentionally left out of DECISIONS below — see prior discussion,
  // its meaning wasn't distinct from the other three decisions.
  export const STATUS = {
    PENDING: { label: "Pending", color: colors.secondary, background: "#F1F2F4" },
    MAKEUP: { label: "Makeup Scheduled", color: colors.blue, background: colors.blueLight },
    ADJUSTMENT: { label: "Adjusted", color: colors.primary, background: colors.primaryLight },
    REJECTED: { label: "Rejected", color: colors.red, background: colors.redLight },
    APPROVED: { label: "Approved", color: colors.green, background: colors.greenLight },
  };
  
  export const DECISIONS = [
    { value: "MAKEUP", label: "Schedule Makeup" },
    { value: "ADJUSTMENT", label: "Adjustment" },
    { value: "REJECTED", label: "Reject" },
  ];
  
  export const MONTHS = [
    { value: 1, label: "January" },
    { value: 2, label: "February" },
    { value: 3, label: "March" },
    { value: 4, label: "April" },
    { value: 5, label: "May" },
    { value: 6, label: "June" },
    { value: 7, label: "July" },
    { value: 8, label: "August" },
    { value: 9, label: "September" },
    { value: 10, label: "October" },
    { value: 11, label: "November" },
    { value: 12, label: "December" },
  ];
  
  export const formatDate = (value) => {
    if (!value) return "\u2014";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "\u2014";
    return date.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };
  
  export const formatTime = (value) => {
    if (!value) return "";
    const [hour, minute] = value.split(":");
    const date = new Date();
    date.setHours(Number(hour), Number(minute), 0);
    return date.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" });
  };